export function getInitialValues(participantData = {}) {
  return {
    firstName: participantData?.firstName || '',
    lastName: participantData?.lastName || '',
    title: participantData?.title?.value || '',
    gender: participantData?.gender?.value || '',
    language: participantData?.nativeLanguage?.value || '',
    function: participantData?.function || '',
    companyName: participantData?.company?.name || '',
    department: participantData?.department || '',
    customerReference: participantData?.customerReference || '',
    isBookingPerson: participantData.attendeeDto?.isBookingPerson || false,
    vatNumber: participantData.linkedPersonDto?.vatno || '',
    email: (participantData?.emailDtos?.length && participantData?.emailDtos[0].email) || '',
    phone: (participantData?.phoneDtos?.length && participantData?.phoneDtos[0].phone) || '',
    mobile: '',
    street: (participantData?.addressDtos?.length && participantData?.addressDtos[0].street) || '',
    number: (participantData?.addressDtos?.length && participantData?.addressDtos[0].number) || '',
    postCode:
      (participantData?.addressDtos?.length && participantData?.addressDtos[0].postalCode) || '',
    city: (participantData?.addressDtos?.length && participantData?.addressDtos[0].city) || '',
    region:
      (participantData?.addressDtos?.length && participantData?.addressDtos[0].region?.value) || '',
    country:
      (participantData?.addressDtos?.length && participantData?.addressDtos[0].country?.value) ||
      '',
    communicationAddressType: 'alternative', // default selection
    // Conditional fields when 'alternative' is selected
    alternativeCommunicationAddress: {
      title: participantData?.communicationData?.title?.value || '',
      firstName: participantData?.communicationData?.firstName || '',
      lastName: participantData?.communicationData?.lastName || '',
      email: participantData?.communicationData?.emailDto?.email || '',
      mobile: participantData?.communicationData?.mobileDto?.phone || '',
      phone: participantData?.communicationData?.phoneDto?.phone || '',
      companyName: participantData?.communicationData?.companyName || '',
      street: participantData?.communicationData?.addressDto?.street || '',
      number: participantData?.communicationData?.addressDto?.number || '',
      city: participantData?.communicationData?.addressDto?.city || '',
      postCode: participantData?.communicationData?.addressDto?.postalCode || '',
      region: participantData?.communicationData?.addressDto?.region?.value || '',
      country: participantData?.communicationData?.addressDto?.country?.value || ''
    },
    hotelRequest: participantData?.hotelRequest ? 'yes' : 'no',
    arrivalDate: participantData?.arrivalDate || null,
    departureDate: participantData?.departureDate || null,
    foodPreferences: {
      vegan: participantData?.isVegan,
      vegetarian: participantData?.isVegetarian
    },
    healthNeeds: {
      handicapped: participantData?.isHandicap
    },
    allergies: participantData?.allergies || [],
    customFields: participantData?.customFieldValueResponseDtos || []
  };
}

export function extractMetaData(participantData = {}) {
  return {
    titles: [participantData?.title?.value || ''],
    genders: [participantData?.gender?.value || ''],
    languages: [participantData?.nativeLanguage?.value || ''],
    countriesGeneral: [participantData?.addressDtos?.[0]?.country?.value || ''],
    regionsGeneral: [participantData?.addressDtos?.[0]?.region?.value || ''],
    countriesCommunication: [participantData?.communicationData?.addressDto?.country?.value || ''],
    regionsCommunication: [participantData?.communicationData?.addressDto?.region?.value || '']
  };
}
